fx.ns("models", class ProductCalendar extends  models.Creation {

	constructor(data)
	{
		super(data);

        this.product_type_id = models.ProductType.CALENDAR;
	}
	

    get totalPrice()
    {
		return (this.creationOption.price_base * fx.get("lang").tax).toFixed(2); 
    }

    get pageWidth()
    {
        return 210;//this.creationOption.format.width;
    }

    get pageHeight()
    {
        return 300;//this.creationOption.format.height;
    }

    get format()
    {
        return this.creationOption.format;
    }

    get option()
    {
        return this.creationOption.option;
    }

    get creationOption()
    {
        return this.creationOptions.find({formatid : this.formatid, option_id : this.optionid})
    }

    get creationOptions()
    {
        return this._creationOptions;
    }

    set creationOptions(val)
    {
        this._creationOptions = val;
    }

    calculatePrice()
	{
        return this.totalPrice + " €" ;
	}

});
